/* eslint-disable vue/no-mutating-props */
<template>
  <div class="single-line-field w-full">
    <p for="input" class="block text-sm mb-2 font-semibold text-argus-forest-800">
      {{ field.label }}
      <span v-if="field.required" class="text-argus-error text-sm">*</span>
    </p>

    <div class="flex flex-row">
      <div class="w-1/2 md:flex-1 mr-3">
        <Dropdown
          :options="months"
          :initial="initialMonth"
          @select="updateMonth"
          placeholder="Month"
          dropDownSize="h-[150px]"
        />
      </div>
      <div class="w-1/4 md:flex-1 mr-3">
        <Dropdown
          :options="days"
          :initial="initialDay"
          @select="updateDay"
          placeholder="Day"
          dropDownSize="h-[150px]"
        />
      </div>

      <div class="w-1/4 md:flex-1 mr-3">
        <input
          type="text"
          ref="input"
          name="input"
          class="w-full px-3 py-2 text-sm text-argus-forest-600 border border-argus-border focus:border-argus-border rounded-lg placeholder-argus-forest-600 placeholder-opacity-50"
          :value="year"
          autocomplete="off"
          data-private
          @input="year = $event.target.value"
          v-maska="'####'"
          placeholder="Year"
        />
      </div>
    </div>

    <template v-if="field.error || !!errorMessage">
      <p class="text-argus-error text-sm py-[4px]">{{ errorMessage }}</p>
    </template>
    <template v-else-if="field.help_text">
      <p class="text-argus-forest-600 text-sm py-[4px]">{{ field.help_text }}</p>
    </template>
  </div>
</template>
<script>
// import validator from 'validator'
import moment from 'moment'
import { vMaska } from 'maska/vue'

import { months, days } from '@/constants/dateOptions'

export default {
  props: {
    field: Object,
  },
  directives: { maska: vMaska },
  emits: ['update'],
  computed: {
    formattedDate() {
      if (this.field.specificity === 'year') {
        if (!this.month) {
          return this.year
        }

        if (!this.day) {
          return `${this.year}-${this.month}`
        }

        return `${this.year}-${this.month}-${this.day || '01'}`
      } else if (this.field.specificity === 'month') {
        if (!this.year || !this.month) {
          return ''
        }
        if (!this.day) {
          return `${this.year}-${this.month}`
        }
      }

      return `${this.year}-${this.month}-${this.day}`
    },
    validDate() {
      if (this.field.specificity === 'year') {
        return !!this.year
      } else if (this.field.specificity === 'month') {
        if (!this.day) {
          return moment(this.formattedDate, 'YYYY-MM', true).isValid()
        }
      }

      return moment(this.formattedDate, 'YYYY-MM-DD', true).isValid()
    },
    isValid() {
      if (!this.field.value && this.field.required) {
        return false
      }

      if (this.field.value && !this.validDate) {
        return false
      }

      return true
    },
  },
  watch: {
    year() {
      this.updateValue()
    },
  },
  data() {
    return {
      touched: false,
      errorMessage: '',
      value: '',
      months,
      days,
      year: null,
      month: null,
      day: null,
      initialMonth: null,
      initialDay: null,
    }
  },
  mounted() {
    if (this.field.value) {
      this.month = this.field.value.split('-')[1]
      this.day = this.field.value.split('-')[2]
      this.initialMonth = this.months.find((m) => m.value === this.month)
      this.initialDay = this.days.find((m) => m.value === this.day)
      this.year = this.field.value.split('-')[0]
    }
  },
  methods: {
    updateMonth(val) {
      if (val.value) {
        this.month = val.value
        this.updateValue()
      }
    },
    updateDay(val) {
      if (val.value) {
        this.day = val.value
        this.updateValue()
      }
    },
    updateValue(ev) {
      this.touched = true
      this.$emit('update', this.formattedDate)
    },
    validateField() {
      if (!this.isValid) {
        if (this.field.required && !this.field.value) {
          this.errorMessage = 'This field is required.'
          return
        }
      } else {
        this.errorMessage = ''
      }
    },
  },
}
</script>
<style scoped>
input[type='text']:focus {
  outline: none;
  box-shadow: none;
}
</style>
